package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.example.mystybag.appCore.logic.pages.FavoritesPageViewModel
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.common.extensions.scrollEdgeFade
import com.example.mystybag.core.ui.theme.LocalTheme.p32

@Composable
fun FavoritesPageView(viewModel: FavoritesPageViewModel) {
    val uiState = viewModel.uiState.subscribeAsState()
    val isWeb = PlatformHelper.isWeb
    val gridColumns = if (isWeb) 4 else 2
    val horizontalSpacing = if (isWeb) 20.dp else 8.dp
    val verticalSpacing = if (isWeb) 20.dp else 8.dp
    val webFrameWidth = 1080.dp
    val webGridWidth = webFrameWidth - (horizontalSpacing * (gridColumns - 1))
    val webCardWidth = (webGridWidth - (horizontalSpacing * (gridColumns - 1))) / gridColumns.toFloat()

    BottomSheetUIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        removeVerticalPadding = true,
        navigationContent = null,
        showTopBar = false,
        bottomSheetFactory = {},
        applyBottomInsetSpacer  = false
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            // Figma: Frame 103 – 380x44; Display Small SemiBold 36, On Surface; 80dp from status bar to title
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = p32, bottom = 20.dp),
                contentAlignment = Alignment.Center
            ) {
                Box(
                    modifier = Modifier
                        .then(if (isWeb) Modifier.width(webGridWidth) else Modifier)
                        .fillMaxWidth()
                        .height(44.dp)
                        .padding(horizontal = p16),
                    contentAlignment = Alignment.CenterStart
                ) {
                    Texts.DisplaySmall(
                        text = sharedString(SR.strings.favorites),
                        color = AppTheme.current.colors.onSurface,
                        textAlign = TextAlign.Start
                    )
                }
            }

            if (uiState.value.favorites.isEmpty()) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(p16),
                    contentAlignment = Alignment.Center
                ) {
                    Texts.BodyLarge(text = sharedString(SR.strings.favorites))
                }
            } else {
                // Figma: Row View 380px, itemSpacing 8; Merchant Card 186x248, cornerRadius 24, padding 16
                Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.TopCenter
                ) {
                    LazyVerticalGrid(
                        columns = GridCells.Fixed(gridColumns),
                        modifier = Modifier
                            .then(
                                if (isWeb) {
                                    Modifier
                                        .width(webGridWidth)
                                        .fillMaxHeight()
                                } else {
                                    Modifier
                                        .fillMaxSize()
                                }
                            )
                            .scrollEdgeFade(
                                showTop = false,
                                edgeSize = 14.dp,
                                overlayColor = AppTheme.current.colors.background.copy(alpha = 0.65f)
                            ),
                        contentPadding = PaddingValues(
                            start = if (isWeb) 0.dp else p16,
                            top = 0.dp,
                            end = if (isWeb) 0.dp else p16,
                            bottom = p16
                        ),
                        horizontalArrangement = Arrangement.spacedBy(horizontalSpacing),
                        verticalArrangement = Arrangement.spacedBy(verticalSpacing)
                    ) {
                        items(uiState.value.favorites, key = { it.id }) { item ->
                            HomeTopPickCard(
                                model = item,
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .aspectRatio(186f / 248f),
                                cardWidth = if (isWeb) webCardWidth else 186.dp,
                                onClick = { viewModel.onTopPickClick(item) },
                                onFavouriteClick = { viewModel.onRemoveFavorite(item) },
                                showFavoriteButton = true
                            )
                        }
                    }
                }
            }
        }
    }
}
